module.exports = __webpack_public_path__ + "img/arh_3.2cc05a09.jpg";